export default "__VITE_ASSET__DcQdt9sj__"